<script setup>
import List from '@/Components/Models/Invoice/List.vue';
import SectionCard from '@/Shared/VisualComponents/SectionCard.vue'
import { Inertia } from '@inertiajs/inertia'
import { PencilAltIcon } from "@heroicons/vue/outline"
import { ref } from 'vue'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
    organisation: {
        type: Object,
        default: () => ({}),
    },
    invoices: {
        type: Array,
        default: () => [],
    },
    hasFetchedInvoices: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits([
    'item-clicked',
    'invoices-loaded',
    'invoices-error',
])

const loadingError = ref(null)

function invoicesError(error){
	loadingError.value = error
}

function rowClicked(data){
	emit('item-clicked', data)
}

function editOrganisation(){
	Inertia.visit(route('dashboard.organisations.edit', props.organisation.id))
}

function invoicesLoaded(invoices){
	emit('invoices-loaded', invoices)
}

</script>

<template>
	<SectionCard title="Invoices" :full-width="true" >
		<List 
			:organisation="organisation" 
			:invoices="invoices" 
			:has-fetched-invoices="hasFetchedInvoices"
			@invoices-error="invoicesError"
			@invoices-loaded="invoicesLoaded" 
			@item-clicked="rowClicked"
		/>

		<template #footer>
			<div class="d-flex flex-row items-center text-center w-full h-full">
				<p class="text-xs text-gray-500 flex items-center mr-2 italic" v-if="loadingError">
					{{ loadingError.message }}
				</p>
				<p class="text-xs text-gray-500 flex justify-center mr-2 italic" v-if="!organisation.xero_id && auth.isAdmin">
					This organisation does not have a Xero ID set. Please add a Xero ID in order to view invoices.
				</p>
				<div class="flex justify-end mt-2">
					<Button
						v-if="(loadingError || !organisation.xero_id) && auth.isAdmin"
						@click="editOrganisation" 
						class="block text-center justify-end" 
						color="blue"
						data-testid="edit-details-btn"
					>
						<PencilAltIcon class="w-4 h-4 mr-2 inline" /> Edit Organisation
					</Button>
				</div>
			</div>
		</template>
	</SectionCard>
</template>